export default {
    loginVue: {
        loginTitle: 'Prihlásenie',
        emailPlaceholder: 'E-mail',
        passwordPlaceholder: 'Heslo',
        loginButton: 'Prihlásiť sa',
    },
    addEditModalVue: {
        modalAddTitle: 'Pridať dodávateľa',
        modalEditTitle: 'Upraviť dodávateľa',
        firstNameLabel: 'Meno',
        lastNameLabel: 'Priezvisko',
        companyNameLabel: 'Názov spoločnosti / Obchodné meno',
        emailLabel: 'E-mail',
        phoneLabel: 'Telefónne číslo',
        streetLabel: 'Ulica a číslo domu',
        postalCodeLabel: 'Poštové smerovacie číslo (PSČ)',
        cityLabel: 'Mesto',
        countryLabel: 'Krajina',
        businessIDLabel: 'Identifikačné číslo organizácie (IČO)',
        taxIDLabel: 'Daňové identifikačné číslo (DIČ)',
        VATRegistrationNumberLabel: 'Identifikačné číslo pre daň z pridanej hodnoty (IČ-DPH)',
        registerTypeLabel: 'Typ registra',
        registerTypeTrade: 'Živnostenský register (ZRSR)',
        registerTypeBusiness: 'Obchodný register (ORSR)',
        registerDistrictLabel: 'Zapísané v kraji',
        selectDefault: 'Vyberte si možnosť',
        registerNoLabel: 'Pod číslom',
        ibanLabel: 'IBAN',
        invoiceNumberLabel: 'Prefix faktúry',
        multisportLabel: 'MultiSport karta (Zašktnite ak ÁNO)',
        taxPayerLabel: 'Platiteľ dane (Zašktnite ak ÁNO)',
        taxRateLabel: 'Výška platenej dane',
        rateLabel: 'Sadzba',
        activeIncomeLabel: 'Aktívna zložka',
        pasiveIncomeLabel: 'Pasívna zložka',
        fitstNameErrorTitle: 'Žiadne meno?!',
        firstNameErrorText: 'Naozaj váš dodávateľ nemá meno?',
        lastNameErrorTitle: 'Bez priezviska?!',
        lastNameErrorText: 'Ste si istý že Váš dodávateľ nemá žiadne priezvisko?',
        companyNameErrorTitle: 'Eh... Žiadne meno spoločnosti alebo obchodné meno?!',
        companyNameErrorText: 'Váš dodávateľ naozaj nemá obchodné meno alebo meno spoločnosti?',
        emailErrorTitle: 'Bez email-u?!',
        emailErrorText: 'Ale no tak... Každý má už dnes email...',
        phoneErrorTitle: 'Telefónne číslo?!',
        phoneErrorText: 'Bez telefónneho čísla nebudú žiadne hovory...',
        streetErrorTitle: 'Naozaj?! Bez ulice?',
        streetErrorText: 'Bez ulice nebude žiadna holubia pošta',
        postalCodeErrorTitle: 'Počkať! Žiadne PSČ?',
        postalCodeErrorText: 'Chúďatká holuby... Ako asi nájdu Váš cieľ?',
        cityErrorTitle: 'Žiadne mesto?!',
        cityErrorText: 'Váš dodávateľ žije v džungli?',
        countryErrorTitle: 'Bez krajiny?!',
        countryErrorText: 'Je váš dodávateľ Marťan?',
        taxIDErrorTitle: 'Ozaj? Žiadne IČO?',
        taxIDErrorText: 'Bez IČO nebudú žiadne peniaze pre dodávateľa a to nechceme',
        registerTypeErrorTitle: 'Žiaden typ registra!',
        registerTypeErrorText: 'Váš dodávateľ nie je zapísaný v žiadnom registri? Hmmm...',
        registerDistrictErrorTitle: 'Pole zapísané v kraji je nevybraté!',
        registerDistrictErrorText: 'V akom kraji je zapísaný?',
        registerNoErrorTitle: 'Pole zapísaný pod číslom je prázdne!',
        registerNoErrorText: 'Štát mu neprideli žiadne číslo?',
        ibanErrorTitle: 'Bez IBAN-u?',
        ibanErrorText: 'Ako mám vedieť kam potom poslať peniaze?',
        invoiceNumberErrorTitle: 'Žiaden prefix faktúry?',
        invoiceNumberErrorText: 'Naozaj neche dodávateľ použiť vlastný prefix faktúry?',
        errorButton: 'Dobre rozumiem!'
    },
    indexVue: {
        monthDefault: 'Vyberte si mesiac',
        selectAll: 'Vybrať všetkých',
        timeColumn: 'Čas',
        ratesColumn: 'Sadzba',
        activeColumn: 'Aktívna',
        pasiveColumn: 'Pasívna',
        discountColumn: 'Zľava',
        extraColumn: 'Bonus',
        totalColumn: 'Spolu',
        generatePDFButton: 'Vygenerovať faktúry',
        generateXMLButton: 'Vygenerovať XML pre platobný príkaz',
        sendInvoicesButton: 'Odoslať maily s faktúrami',
        sendInvoicesToAccButton: 'Odoslať maily účtovníkovi',
        deleteContractorErrorTitle: 'Naozaj chcete odstrániť dodávateľa?',
        deleteContractorErrorText: 'Po odstránení nebudete môcť obnoviť tohto dodávateľa!',
        deleteContractorErrorCancelButton: 'Zrušiť',
        deleteContractorErrorOKButton: 'Áno, rozumiem',
        deleteContractorSuccessText: 'Dodávateľ bol úspešne odstránený!',
        deleteContractorInfoTitle: 'Ničoho sme sa nedotkli!',
        deleteContractorInfoText: 'Dodávateľ je v bezpečí!',
        generatePDFSuccessText: 'PDF boli úspešne vygenerované!',
        generateXMLSuccessText: 'XML boli úspešne vygenerované!',
        mailSuccessText: 'Maily boli úspešne odoslané!',
        successTitle: 'Podarilo sa!',
        okButton: 'Dobre',
    }
}
